import { researchStatus } from '@/enums/researchStatus'
import type { C_DU_FLAG, iCommunityResearch } from '@/stores/communityResearch/iCommunityResearch'
import { ContentType } from '@/stores/communityResearch/iCommunityResearch'
import { defineStore } from 'pinia'
import { reactive, readonly, ref } from 'vue'

export const communityResearchStore = defineStore('communityResearch', () => {
  const communityResearch = reactive<iCommunityResearch>({} as iCommunityResearch)

  const getcommunityResearch = readonly(communityResearch)

  const totalCircleRequest = ref<number | null>(null)

  function setCommunityPreview(data: {
    id: number
    article_title: string
    thumbnail: string
    article_category_id: number
    first_summary: string
    second_summary: string
    third_summary: string
    short_description: string
    status: researchStatus
    writter_id: number
    auditor_id: number
    article_slug: string
    updated_at: Date | null
    deleted_at: Date | null
    published_at: Date | null
    created_at: Date | null
    category: {
      id: string
      article_category_name: string
      deleted_at: Date | null
    }
    writter: {
      id: number
      fullname: string
      email: string
      thumbnail: string
      role: string
    }
    totalRequest: number
    content_type: ContentType
    du: C_DU_FLAG
  }) {
    communityResearch.id = data.id
    communityResearch.article_title = data.article_title
    communityResearch.thumbnail = data.thumbnail
    communityResearch.article_category_id = data.article_category_id
    communityResearch.first_summary = data.first_summary
    communityResearch.second_summary = data.second_summary
    communityResearch.third_summary = data.third_summary
    communityResearch.short_description = data.short_description
    communityResearch.status = data.status
    communityResearch.writter_id = data.writter_id
    communityResearch.auditor_id = data.auditor_id
    communityResearch.article_slug = data.article_slug
    communityResearch.updated_at = data.updated_at
    communityResearch.deleted_at = data.deleted_at
    communityResearch.published_at = data.published_at
    communityResearch.created_at = data.created_at
    communityResearch.category = { ...data.category }
    communityResearch.writter = { ...data.writter }
    communityResearch.totalRequest = data.totalRequest
    communityResearch.content_type = data.content_type
    communityResearch.du = data.du
  }
  function setFirstContent(content: string) {
    communityResearch.first_content = content
  }
  function setSecondContent(content: string) {
    communityResearch.second_content = content
  }
  function setResearchStatus(status: researchStatus) {
    communityResearch.status = status
  }
  function setTotalCircleRequest(val: number) {
    totalCircleRequest.value = val
  }
  function setDefault() {
    communityResearch.id = -1
    communityResearch.article_title = ''
    communityResearch.thumbnail = ''
    communityResearch.article_category_id = -1
    communityResearch.first_summary = ''
    communityResearch.second_summary = ''
    communityResearch.third_summary = ''
    communityResearch.short_description = ''
    communityResearch.status = researchStatus.REJECTED
    communityResearch.writter_id = -1
    communityResearch.auditor_id = -1
    communityResearch.article_slug = ''
    communityResearch.updated_at = null
    communityResearch.deleted_at = null
    communityResearch.published_at = null
    communityResearch.created_at = null
    communityResearch.category.id = ''
    communityResearch.category.article_category_name = ''
    communityResearch.writter.id = -1
    communityResearch.writter.fullname = ''
    communityResearch.writter.email = ''
  }
  return {
    getcommunityResearch,
    setCommunityPreview,
    setFirstContent,
    setSecondContent,
    setResearchStatus,
    setDefault,
    totalCircleRequest
  }
})
